import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import PDFViewer from '../components/PDFViewer';

export default function PolicyViewer() {
  const { policyId } = useParams();

  const policyMap = {
    'privacy-policy': {
      title: 'Privacy Policy',
      path: '/policies/Privacy_Policy.pdf'
    },
    'terms-of-service': {
      title: 'Terms of Service',
      path: '/policies/Terms_of_Service.pdf'
    },
    'cookie-policy': {
      title: 'Cookie Policy',
      path: '/policies/Cookie_Policy.pdf'
    },
    'platform-liability-policy': {
      title: 'Platform Liability Policy',
      path: '/policies/Platform_Liability_Policy.pdf'
    },
    'subscription-policy': {
      title: 'Subscription Policy',
      path: '/policies/Subscription_Policy.pdf'
    }
  };

  const policy = policyMap[policyId];

  if (!policy) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-2xl">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Policy niet gevonden</h1>
          <Link to="/legal" className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            Terug naar juridische documenten
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container-professional py-12">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <Link
              to="/legal"
              className="inline-flex items-center space-x-2 text-gray-600 hover:text-ios-blue mb-6 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Terug naar juridische documenten</span>
            </Link>

            <div className="bg-gradient-to-r from-ios-blue to-blue-600 rounded-2xl shadow-lg p-8 text-white">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                  <FileText className="w-8 h-8" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold mb-2">{policy.title}</h1>
                  <p className="text-blue-100">Live PDF weergave</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-8">
            <PDFViewer pdfPath={policy.path} title={policy.title} />
          </div>
        </div>
      </div>
    </div>
  );
}
